/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { ErrorSection } from "@cosmos/components";

export default function NotFound(): React.JSX.Element {
	return (
		<div className="not-found">
			<ErrorSection />
		</div>
	);
}
